module.exports = __webpack_public_path__ + "img/collection-2.b263fbb5.png";